import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { IUser } from "../../components/models/User";
import { IUserAccount } from "../../components/models/UserAccount";
import { RootState } from "..";
import { companyOnboardingStages } from "../../resources/types";
import { ICompanyOnboarding } from "../../resources/interfaces";
import { COMPANY_TYPES } from "../../resources/enums";
// import { signoutUser } from "../../utils/requests";

interface IInitialState {
    PROFILE: IUser;
    ACCOUNT: IUserAccount;
    COMPANY_ONBOARDING: ICompanyOnboarding;
}

const initialState: IInitialState = {
    PROFILE: {
        id: '',
        first_name: '',
        last_name: '',
        email: '',
        gender: undefined,
        avatar_url: undefined,
        is_active: false,
        account_activated_at: null,
        email_verified_at: null,
        company: null
    },
    ACCOUNT: {
        isNew: false,
        accountSession: '',
        accessRight: null,
        userId: '',
        token: '',
        sessionExpired: false
    },
    COMPANY_ONBOARDING: {
        is_onboarded: false,
        current_step: 0,
        data: {
            id: "",
            name: "",
            tin: "",
            license: "",
            registration_number: "",
            address_id: "",
            address: "string",
            region: "",
            city: "",
            digital_address: "",
            type: COMPANY_TYPES.SUSU,
            email: "",
            phone: "",
            country: "", 
            website: ""
        }
    }
};

const userAccountSlice = createSlice({
    name: "userAccount",
    initialState,
    reducers: {
        UPDATE_PROFILE: (state, action: PayloadAction<Partial<IUser>>) => {
            state.PROFILE = {
                ...state.PROFILE,
                ...action.payload
            };
            return state;
        },
        UPDATE_ACCOUNT: (state, action: PayloadAction<Partial<IUserAccount>>) => {
            state.ACCOUNT = {
                ...state.ACCOUNT,
                ...action.payload
            };
            return state;
        },
        SIGN_OUT: (state) => {
            // signoutUser(state.ACCOUNT.accessRight ?? "");
            state = initialState;
            return state;
        },
        UPDATE_COMPANY_ONBOARDING: (state, action: PayloadAction<Partial<ICompanyOnboarding>>) => {
            state.COMPANY_ONBOARDING = {
                ...state.COMPANY_ONBOARDING,
                ...action.payload
            };
            return state;
        },
    }
});

export const getUserAccountState = (state: RootState): RootState => {
    return state;
};

export const getUserProfile = (state: RootState): IUser => {
    return state.userAccount.PROFILE;
}

export const getUserAccount = (state: RootState): IUserAccount => {
    return state.userAccount.ACCOUNT;
}

export const getCompanyOnboarding = (state: RootState): ICompanyOnboarding => {
    return state.userAccount.COMPANY_ONBOARDING;
}

export const isAuthenticated = (state: RootState): boolean => {
    return !!state.userAccount.ACCOUNT.token
}

export const isActivated = (state: RootState): boolean => {
    return !!state.userAccount.PROFILE.is_active
}

export const isOnboarded = (state: RootState): boolean => {
    return !!state.userAccount.COMPANY_ONBOARDING?.is_onboarded;
}

export const getOnboardingStep = (state: RootState): number => {
    return state.userAccount.COMPANY_ONBOARDING?.current_step;
}


export const { UPDATE_PROFILE, UPDATE_ACCOUNT, SIGN_OUT, UPDATE_COMPANY_ONBOARDING } = userAccountSlice.actions;
export default userAccountSlice.reducer;